/*
 * Based on Devia's Kit /src/views/CustomerManagementList/Results.js
 *
 * That file has a lot of good stuff that I've cut out of this one, but that I
 * might want to include in a more featureful List, e.g.
 *   CardActions with TablePagination
 *   CardHeader property: action={<GenericMoreButton />}
 *   Link and RouterLink for more explicit navigation
 *   Powerful checkboxes
 *   Typography for very careful specification of some text
 *   Avatar
 */

import React, { Component } from 'react';
import { connect } from 'react-redux';
import { Redirect } from 'react-router-dom';

import withStyles from '@mui/styles/withStyles';
import {
  Grid,
  IconButton,
  Tooltip,
  Card,
  CardContent,
  CardHeader,
  Divider,
  // Link,
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableRow,
} from '@mui/material';

// mui icons
import { Close } from '@mui/icons-material';

import { makeStyles } from '@mui/styles';

// our own attempt at creating a Twilio Icon (downloaded svg from https://www.stockio.com/free-icon/twilio)
import TwilioIcon from '../assets/img/Twilio';
import CallRailIconImage from '../assets/img/CallRailLogo_24x21.png';

import { setAccounts } from '../store/slices/accountsSlice';
import { setIntendedAccountId } from '../store/slices/intendedInfoSlice';
import { setApiResponseInfo } from '../store/slices/apiResponseInfoSlice';

import { createStdRequest, apiFetch } from '../utils/utils';

import ConfirmModal from '../components/ConfirmModal';

const localStyles = {
  root: {},
  content: {
    padding: 0,
  },
  inner: {
    minWidth: 700,
  },
};

class Accounts extends Component {
  constructor(props) {
    super(props);

    this.state = {
      unauthorized: false,
      toAccountOverview: false,
    };
  }

  componentDidMount() {
    const role = this.props.loggedInRole;
    const onLocalMachine = window.location.hostname === 'localhost';
    if (onLocalMachine || role === 'SuperAdmin' || role === 'AllevaRep') {
      this.fetchTableData();
    } else {
      this.setState({ unauthorized: true });
    }
  }

  fetchTableData() {
    this.setState({ querying: true });
    const uri = '/api/demo/provider';
    const request = createStdRequest(uri);
    const actionOnGoodResponse = (json) => {
      this.props.setAccounts(json);
      this.setState({ querying: false });
    };
    apiFetch(this, request, actionOnGoodResponse);
  }

  sortAccountInfos(providerInfos) {
    return [...providerInfos].sort((a, b) => (a.firmName > b.firmName ? 1 : -1));
  }

  showOverviewOfAccount(firmId) {
    // Call the actionCreator/dispatcher to set the "idOfAccountToShow" in the Redux store
    this.props.setIntendedAccountId(firmId);

    // Set the local state so that the page will refresh and redirect
    this.setState({ toAccountOverview: true });
  }

  showTwilioInfo(firmId) {
    // Call the actionCreator/dispatcher to set the "idOfAccountToShow" in the Redux store
    this.props.setIntendedAccountId(firmId);

    // Set the local state so that the page will refresh and redirect
    this.setState({ redirect: 'firmTwilioInfo' });
  }

  goToCallRailSettingsPage(firmId) {
    // Call the actionCreator/dispatcher to set the "idOfAccountToShow" in the Redux store
    this.props.setIntendedAccountId(firmId);

    // Set the local state so that the page will refresh and redirect
    this.setState({ redirect: 'firmCallRailInfo' });
  }

  confirmAndDeleteAccount(providerId) {
    const accountInfos = this.props.accounts || [];
    const foundInfo = accountInfos.find((info) => info.providerId === providerId) || {};
    const firmName = foundInfo.firmName || 'this account';
    const q = `Are you sure you want to delete ${firmName}?`;
    this.setState({
      shouldShowDeletionConfirmationModal: true,
      deletionConfirmationQuery: q,
      deleteFunc: () => this.deleteAccount(providerId),
    });
  }

  deleteAccount(providerId) {
    const uri = '/api/demo/provider/' + providerId;
    const request = createStdRequest(uri, 'DELETE');
    const actionOnGoodResponse = (json) => {
      this.fetchTableData();
      this.setState({ shouldShowDeletionConfirmationModal: false });
    };
    apiFetch(this, request, actionOnGoodResponse);
  }

  render() {
    if (this.state.unauthorized) {
      return (
        <div>
          <h2>Sorry! You're not allowed to be here.</h2>;
          <h3>You need to be logged in as an AllevaRep or SuperAdmin.</h3>;
        </div>
      );
    }

    if (this.state.toAccountOverview) {
      return <Redirect to="account" push />;
    }

    if (this.state.redirect) {
      return <Redirect to={this.state.redirect} push />;
    }

    const { classes } = this.props;

    const accountInfos = this.sortAccountInfos(this.props.accounts);

    return (
      <div>
        <ConfirmModal
          show={this.state.shouldShowDeletionConfirmationModal}
          title="Confirm Deletion"
          confirmButtonLabel="Delete"
          rejectButtonLabel="Cancel"
          onConfirm={this.state.deleteFunc}
          onReject={() => this.setState({ shouldShowDeletionConfirmationModal: false })}
        >
          <div>{this.state.deletionConfirmationQuery}</div>
        </ConfirmModal>

        <Grid container>
          <Grid item md={1} />
          <Grid item xs={10}>
            <Card>
              <CardHeader title="All Accounts" />
              <Divider />
              <CardContent className={classes.content}>
                <div className={classes.inner}>
                  <Table stickyHeader={true}>
                    <TableHead>
                      <TableRow>
                        <TableCell>Account Name</TableCell>
                        <TableCell>Registration Date</TableCell>
                        <TableCell align="right">Actions</TableCell>
                      </TableRow>
                    </TableHead>
                    <TableBody>
                      {accountInfos.map((accountInfo, i) => (
                        <FirmRow page={this} accountInfo={accountInfo} i={i} key={accountInfo.firmId} />
                      ))}
                    </TableBody>
                  </Table>
                </div>
              </CardContent>
            </Card>
          </Grid>
        </Grid>
      </div>
    );
  }
}

const firmRowStyles = makeStyles((theme) => ({
  root: {},
  whiteRow: {},
  shadedRow: {
    backgroundColor: '#f7f7f7',
  },
}));

const FirmRow = ({ page, accountInfo, i }) => {
  const classes = firmRowStyles();
  const rowStyle = i % 2 === 0 ? classes.whiteRow : classes.shadedRow;
  return (
    <TableRow className={rowStyle}>
      <FirmNameCell page={page} accountInfo={accountInfo} />
      <TableCell>{accountInfo.registrationDate}</TableCell>
      <FirmActionButtons page={page} accountInfo={accountInfo} />
    </TableRow>
  );
};

const createNameCellStyles = makeStyles((theme) => ({
  root: {},
  nameSpan: {
    cursor: 'pointer',
    '&:hover': {
      textDecoration: 'underline',
    },
  },
}));

const FirmNameCell = ({ page, accountInfo }) => {
  const classes = createNameCellStyles();
  return (
    <TableCell>
      <span className={classes.nameSpan} onClick={() => page.showOverviewOfAccount(accountInfo.firmId)}>
        {accountInfo.firmName}
      </span>
    </TableCell>
  );
};

const CallRailIcon = () => {
  return (
    <div>
      <img src={CallRailIconImage} />
    </div>
  );
};

const createTwilioButton = (classes, page, firmId) => (
  <Tooltip id="tooltip-twilio" title="See Twilio Settings" placement="top" classes={{ tooltip: classes.tooltip }}>
    <IconButton className={classes.actionButton} onClick={() => page.showTwilioInfo(firmId)} size="large">
      <TwilioIcon className={classes.red} />
    </IconButton>
  </Tooltip>
);

const createCallRailButton = (classes, page, firmId) => (
  <Tooltip id="tooltip-callrail" title="Edit CallRail Settings" placement="top" classes={{ tooltip: classes.tooltip }}>
    <IconButton className={classes.actionButton} onClick={() => page.goToCallRailSettingsPage(firmId)} size="large">
      <CallRailIcon />
    </IconButton>
  </Tooltip>
);

const createDeleteButton = (classes, page, providerId) => (
  <Tooltip id="tooltip-delete" title="Delete Account" placement="top" classes={{ tooltip: classes.tooltip }}>
    <IconButton className={classes.actionButton} onClick={() => page.confirmAndDeleteAccount(providerId)} size="large">
      <Close className={classes.icon + ' ' + classes.red} />
    </IconButton>
  </Tooltip>
);

const createActionButtonStyles = makeStyles((theme) => ({
  root: {},
  actionButton: {
    margin: '0 0 0 5px',
    padding: '5px',
    '& svg,& .fab,& .fas,& .far,& .fal,& .material-icons': {
      marginRight: '0px',
    },
  },
  icon: {
    verticalAlign: 'middle',
    width: '17px',
    height: '17px',
    top: '-1px',
    position: 'relative',
  },
  red: {
    color: 'red',
  },
}));

const FirmActionButtons = ({ page, accountInfo }) => {
  const classes = createActionButtonStyles();
  const twilioButton = createTwilioButton(classes, page, accountInfo.firmId);
  const callRailButton = createCallRailButton(classes, page, accountInfo.firmId);
  const deleteButton = createDeleteButton(classes, page, accountInfo.providerId);
  return (
    <TableCell align="right">
      {twilioButton} {callRailButton} {deleteButton}
    </TableCell>
  );
};

const mapStateToProps = (state) => ({
  loggedInRole: state.userInfo.role,
  accounts: state.accounts.accounts,
});

const actionProducers = {
  setAccounts,
  setIntendedAccountId,
  setApiResponseInfo,
};

export default connect(mapStateToProps, actionProducers)(withStyles(localStyles)(Accounts));
